<template>
	<div>
		<div class="yt_fixed">
			<div class="yt_title">
			<img :src="logo" alt="">
				<a href="/#/search"><van-icon name="search" slot="right" ></van-icon></a>
			</div>
			<div class="yt_nav">
				<ul>
					<li style="display: block" v-for="item in channels" :key="item.class_id"><a :href="'/#/typelist/'+item.class_id">{{ item.class_name }}</a></li>
				</ul>
			</div>
		</div>
		<div class="yt_body" v-if="images.length>0">
			<van-swipe class="yt_banner" :autoplay="3000">
			<van-swipe-item v-for="(image, index) in images" :key="index">
				<a :href="image.biaoqian=='专题' ? image.Url : '/#/detail/'+image.tid">
				 <img :src="image.PicUrl" />
				</a>
			</van-swipe-item>
		</van-swipe>
		</div>
		<div class="yt_qz" v-for="(classinfo,index) in newsData" :key="index">
			<div class="yt_qz-title">
				<h1><a :href="'/#/typelist/'+classinfo.class_id">{{ classinfo.class_name }}</a></h1>
				<i></i>
			</div>
			<ul>
				<li v-for="(item,index) in classinfo.data" :key="index">
					<a :href="item.biaoqian=='专题' ? item.Url : '/#/detail/'+item.tid">
					<h1>{{item.title}}</h1>
					<p> {{ item.PublishTime|moment("from","now",true)}}</p>
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
	import Vue from 'vue';
	const moment = require('moment')
	require('moment/locale/zh-cn')
	Vue.use(require('vue-moment'), {
	    moment
	})
	Vue.moment().locale();
	import {Dialog} from 'vant'
	export default{
		data(){
			return{
				images: [
					'https://img.yzcdn.cn/vant/apple-1.jpg',
					'https://img.yzcdn.cn/vant/apple-2.jpg'
				],
				channels:[],
				newsData:[],
				loading:false,
				finished:false,
				error:false,
				page:1,
        logo:'',
        appid:0,
        site:''
			}
		},
		methods:{
			toSearch(){
				this.$router.push('/search');
			},
			toLinks(){
				this.osUrl();
			},
			async getList(id,type='',class_name=''){
				await this.$http.get(this.baseUrl+'/v1/news/lists?appid='+this.appid+"&classid="+id)
				.then((res)=>{
				    if(res.data.statecode==1){
				          if(type=='focus'){
                    this.images = res.data.data.data
                  }else{
				            this.newsData.push({class_id:id,class_name:class_name,data:res.data.data.data.slice(0,6)})
                  }
            }else{
				        Dialog.alert({message:res.data.message})
            }
				})
				.catch(err=>{
          Dialog.alert({message:err})
				})
			},
		},
		mounted() {
        this.$http.get(this.baseUrl+'/v1/news/site?appid='+this.appid+"&url="+window.location.host).then(async (res)=>{
        // this.$http.get(this.baseUrl+'/v1/news/site?appid='+this.appid+"&url=m-zzxq-xhncloud.voc.com.cn").then(async (res)=>{
          if(res.data.statecode==1){
              if(res.data.data.app_id!=undefined){
                 var webname = res.data.data.webname;
                 var appid = res.data.data.app_id;
                 var logo = res.data.data.logo;
                 document.title = '首页-'+webname;
                 this.appid = appid;
                 this.logo = logo;
                 this.channels  = res.data.data.cate
                 if(res.data.data.focus){
                   await this.getList(res.data.data.focus.class_id,'focus');
                 }
                 if(res.data.data.rec.length>0){
                   var cate = res.data.data.rec;
                   for(var i = 0;i<cate.length;i++){
                      await this.getList(cate[i].class_id,'',cate[i].class_name,i);
                   }
                 }
                 localStorage.setItem("webname",webname)
                 localStorage.setItem("appid",appid)
                 localStorage.setItem("logo",logo)
				 localStorage.setItem("org_id",res.data.data.org_id)
				 var _paq = window._paq = window._paq || [];
				/* tracker methods like "setCustomDimension" should be called before "trackPageView" */
				_paq.push(['setCustomVariable', 1, "channel_id", "WAP", "page"]);
				_paq.push(['setCustomVariable', 2, "screen", "news_index", "page"]);
				_paq.push(['trackPageView']);
				_paq.push(['enableLinkTracking']);
				(function() {
					var u="https://click-xhncloud.voc.com.cn/";
					_paq.push(['setTrackerUrl', u+'matomo.php']);
					_paq.push(['setSiteId', res.data.data.org_id]);
					var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
					g.type='text/javascript'; g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
				})();
              }else{
                Dialog.alert({message:"appid不存在"})
              }
          }else{
            Dialog.alert({message:res.data.message})
          }
        })
		}
	}
</script>

<style scoped>
*{
	box-sizing: border-box;
}
a{
	color: #000;
}
.yt_title{
	width: 100%;
	height:110px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	font-size: 46px;
	color: #fff;
	background-color:#e80214;
	text-align: center;
	line-height: 46px;
}
.yt_title>a i{
	position: absolute;
	color: #fff;
	top: 50%;
	transform: translateY(-50%);
	right: 36px;
}
.yt_nav{
	width: 100%;
	padding: 38px 36px 35px 36px;
	background: #fff;
}
.yt_nav>ul{
	display: flex;
	justify-content: flex-start;
  flex-wrap: wrap;
	font-size: .453333rem;
}
.yt_nav>ul>li{
  margin-top: .253333rem;
  margin-right: .2rem;
}
.yt_fixed{
	width: 100%;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 100;
}
.yt_fixed img{
	width:246px;
	height:74px;
}
.yt_body{
	margin-top: 272px;
}
.yt_banner{
	width: 100%;
	height: 450px;
}
.yt_banner img{
	width: 100%;
	height: 100%;
}
.yt_tt>ul{
	width: 100%;
	padding: 0 38px;
}
.yt_tt>ul>li{
	height: 147px;
	border-bottom: 1px solid #e5e5e5;
	font-size: 32px;
	color: #333;
	display: flex;
	align-items: center;
}
.yt_tt>ul>li img{
	width: 78px;
	height: 34px;
	margin-right: 15px
}
.yt_tt>ul>li>span{
	text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.yt_qz-title{
	width: 100%;
	padding: 0 36px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.yt_qz-title h1{
	font-size: 34px;
	font-weight: bold;
	color: #333;
	position: relative;
	padding-left: 22px;
}
.yt_qz-title h1::before{
	content: "";
	width: 10px;
	height: 30px;
	background:url(../assets/tiao.png)no-repeat;
	background-size: 100% 100%;
	position: absolute;
	left: 0;
	top: 50%;
	margin-top: -15px;
}
.yt_qz-title i{
	width: 16px;
	height: 16px;
	border-top: 1px solid #e5e5e5;
	border-right: 1px solid #e5e5e5;
	transform: rotate(45deg)
}
.yt_qz>ul{
	width: 100%;
	padding: 0 36px;
}
.yt_qz>ul>li{
	height: 143px;
	border-bottom: 1px solid #e5e5e5;
}
.yt_qz>ul>li h1{
	font-size: 32px;
	color: #333;
	font-weight: normal;
	white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
	margin: 0;
	margin-top: 30px;
}
.yt_qz>ul>li p{
	font-size: 24px;
	color: #888;
	margin: 0;
	margin-top: 20px;
}
.yt_ph_pc{
	width: 100%;
	text-align: center;
	height: 88px;
	line-height: 88px;
	color: #333;
	font-size: 26px;
	margin-bottom: 50Px;
}
.yt_ph_pc>a{
	font-size: 26px;
	color: #333;
}
.nav_bottom{
	width: 100%;
	height: 50Px;
	background: #fff;
	position: fixed;
	left: 0;
	bottom: 0;
	z-index: 100;
	border-top: 1Px solid #eee;
	display: flex;
	align-items: center;
	box-shadow: 1px -3px 62px 0px 
		rgba(9, 1, 3, 0.15);
}
.nav_b_logo{
	height: 50Px;
	display: flex;
	align-items: center;
}
.nav_b_logo img{
	width: 35Px;
	margin: 0 10Px;
}
.open_btn{
	float: right;
	height: 30Px;
	line-height: 30Px;
	margin-right: 10Px;
}
.van-cell:not(:last-child)::after {
	right: 16Px;
	left: 16Px;
	border-bottom: 1Px solid #ddd;
}
.van-cell{
	padding: 12Px 16Px 6Px;
}
</style>
